import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import jwtAxios from '@crema/services/auth/jwt-auth'

const DocumentViewer = ({ url }) => {

  const getLabelSign = (url) => {
    jwtAxios.get(url, { responseType: 'blob' }).then((data) => {
      window.sign_file_blob = data.data;
    }).catch((error) => {
      console.debug("error ", error);
    })
  }

  const openPDF = async (data) => {
    const iframe = document.querySelector("#iframeLPMUKP");
    // const wrapper = document.querySelector("#wrapperIframe")
    if (iframe) {
      // wrapper.appendChild(iframe);
      iframe.onload = function () {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

        // Inject custom styles into the iframe
        const style = iframeDoc.createElement("style");
        style.textContent = `
                        #editorModeButtons #editorFreeText,
                        #editorModeButtons #editorInk,
                        #editorModeButtons #editorStamp {
                            display: none !important; /* Hide specific annotations */
                        }
                    `;

        iframeDoc.head.appendChild(style);

        // Open the PDF file in the viewer
        iframe.contentWindow?.PDFViewerApplication.open(data);
      };
    }
  }

  useEffect(() => {
    if (url !== null) {
      let file = url
      let labelSign = window.location.protocol + "//" + window.location.host + '/assets/images/Tandatangan.png';

      openPDF(file);
      getLabelSign(labelSign);
    }
  }, [url])

  return (
    url !== null && (
      <iframe src='/assets/latest-pdfjs-dist/web/viewer.html' id='iframeLPMUKP' style={{ height: '100%', border: 0 }} />
    )
  )
}

DocumentViewer.propTypes = {
  url: PropTypes.any,
}

export default DocumentViewer
